document.addEventListener("DOMContentLoaded", () => {
    const pdfEmbed = document.querySelectorAll("#pdf_download");
    pdfEmbed.forEach(pdflink => {
    const pdfURL = pdflink.getAttribute("src");
    const preloadLink = document.createElement("link");
    preloadLink.rel = "preload";
    preloadLink.as = "document";
    preloadLink.href = pdfURL;
    document.head.appendChild(preloadLink);
    });

    const downloadLinks = document.querySelectorAll(".auto-download");
    downloadLinks.forEach(link => {
        link.addEventListener("click", event => {
            event.preventDefault();
            const fileURL = link.getAttribute("href");
            //const fileName = fileURL.split('/').pop().split('?')[0];
            const fileName = "Dr.Crista.pdf";
            fetch(fileURL)
                .then(response => response.blob())
                .then(blob => {
                    const blobURL = window.URL.createObjectURL(blob);
                    const tempLink = document.createElement("a");
                    tempLink.href = blobURL;
                    tempLink.setAttribute("download", fileName);
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    window.URL.revokeObjectURL(blobURL);
                })
                .catch(() => {
                    console.log("Failed to download file.");
                });
        });
    });
});
